import API from "../../axios.jsx";

const BASE = "/bac/mrcv";

export const getMrcvRegistros    = (params) => API.get(BASE, { params });
export const crearMrcvRegistro   = (datos, config) => API.post(BASE, datos, config);
export const editarMrcvRegistro  = (id, datos, config) => API.put(`${BASE}/${id}`, datos, config);
export const eliminarMrcvRegistro = (id) => API.delete(`${BASE}/${id}`);
export const exportarMrcv        = (params) => API.get(`${BASE}/exportar`, { params, responseType: "blob" });
